<template>
	<div id="reportFormTemplate"  class="public-content">
		<!-- 公共form表单样式 -->
		<div class="form-item-public">
			<el-form label-width="70px" inline label-position="left">
				<el-form-item label="会计准则">
					<el-select placeholder="请选择" size="small" v-model='form.prosetId' @change="ifChanges">
						<el-option v-for='item in options.prosetes' :label="item.name" :value="item.id" :key="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="报表模板">
					<el-select placeholder="请选择" size="small" v-model='form.type' @change="ifChanges">
						<el-option v-for='item in options.reportFormType' :label="item.label" :value="item.value" :key='item.id'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button size="small" class='minButton' @click='reportFormTemplateList'>搜索</el-button>
				</el-form-item>

				<el-form-item class="right-position">
					<el-button size="small" class='minButton' @click="dialogShow">添加</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!-- 公共table 样式 -->
		<div class="table-item-public">
			<public-table :table='tableData' @onHandleoperate="handleOperation">
				<template slot-scope="props" slot="name">
					<span v-if='props.scope.row.formulaType==3' v-text='props.scope.row.name'></span>
					<a v-else href="javascript:;" v-text="props.scope.row.name" @click="handlerClick(props.scope.row)"></a>
				</template>
			</public-table>
		</div>

		<!-- 添加公式弹出层 -->
		<el-dialog title="添加报表模板" :visible.sync="dialog.modal" width="420px" :close-on-click-modal="false" class='default-dialog'>
			<div class="form-item-public">
				<el-form  label-width="70px" ref="form" :model="form" :rules="dialogRules">
					<el-form-item prop="name" label="名称:">
						<el-input v-model="form.name" size="mini" placeholder="请输入名称!"></el-input>
					</el-form-item>
					<el-form-item prop="rowNum" label="行号:">
						<el-input-number v-model="form.rowNum" size="mini" placeholder="请输入名称!" controls-position="right" :min="0"></el-input-number>
					</el-form-item>
					<el-form-item prop="orederBy" label="排序:">
						<el-input-number v-model="form.orederBy" size="mini" placeholder="请输入名称!" controls-position="right" :min="0"></el-input-number>
					</el-form-item>
					<!-- <el-form-item prop="isFormula" label="列数:">
						<el-input-number v-model="form.isFormula" size="mini" placeholder="请输入名称!" controls-position="right" :min="0"></el-input-number>
					</el-form-item> -->
					<el-form-item prop="formulaType" label="类型:">
						<el-select v-model="form.formulaType" size="small">
							<el-option v-for='item in options.formulaTypeArray' :label="item.label" :value="item.value" :key='item.value'></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="formulaType" label="资产类型:">
						<el-select v-model="form.itemType" size="small">
							<el-option v-for='item in options.itemTypeList' :label="item.label" :value="item.value" :key='item.value'></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="isFormula " label="公式类型:">
						<el-select v-model="form.isFormula " size="small">
							<el-option v-for='item in options.formulaArray' :label="item.label" :value="item.value" :key='item.value'></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer-right">
				<el-button size="small" @click="dialog.modal = false">取消</el-button>
				<el-button size="small" class='minButton' @click="addReportMethod">确定</el-button>
			</div>
		</el-dialog>


		<super-report-dialogs
			:dialogVisible="isShowReport"
			:datas="reportDialogData"
			:prosetId="form.prosetId"
			:showRegulation="false"
			@onShowDialog="showDialog"
			@onRefresh="refresh">
		</super-report-dialogs>
	</div>
</template>

<script>
import publicTable from '@/components/publicTable'
import superReportDialogs from '@/components/dialog/superReportDialogs'
import { getAccountingList } from "@/api"
export default {
	components:{
		publicTable,
		superReportDialogs
	},
	data(){
		return {
			isShowReport: false, // 是否显示弹窗
      ifSearchs:false,
			reportDialogData: { // 弹窗参数
				reportFormTemplateId: '',
				prosetId: '',
				yearPeriods: '',
				style: '',
        shows:false,  //2017-12-9  当为 民间非盈利组织 业务活动表 并且为内容名称时
			},
			form: { // 筛选条件
				type: 1,
				itemType: '', // 资产类别
				prosetId: 80,
				formulaType: '',
				isFormula: '',
				rowNum: 1,
				orederBy: 1,
				name: '',
				id: ''
			},
			options: { // 选择框option数据
				formulaArray:[{//公式类别
					label: '普通公式',
					value: 1,
				}, {
					label: '非公式',
					value: 0,
				}, {
					label: '可选择输入值',
					value: 2,
				}],
				formulaTypeArray: [{
					label: '内容名称',   // 选择科目
					value: 1,
				}, {
					label: '分类汇总',     // 选择报表
					value: 2,
				}, {
					label: '分类名称',
					value: 3,
				}, {
					label: '汇总',         // 选择报表
					value: 4,
				}],
				reportFormType: [],
				itemTypeList:[
					{
						label: '资产',
						value: 1
					},{
						label: '负债',
						value: 2
					}

				],
				prosetes: [],
			},

			title:'这个是主页',
			dialog:{
				modal:false
			},
			dialogRules:{

			},
			page:{
				pageIndex:1,
				pageSize:10,
				totall:100,
			},
			tableData: {
				border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,				// 是否显示加载动画
				hasSelect: false,			// 是否显示多选
				hasOperation: true,		// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				hasShowPagination: false,	// 是否显示分页
				config: [{
						label: 'id',
						value: 'id',
						show: 'normal'
					}, {
						label: '名称',
						value: 'name',
						show: 'template'
					}, {
						label: '公式类型',
						value: 'isFormula',
						show: 'normal',
						formatter: this.formatter
					},{
						label: '类型',
						value: 'formulaType',
						show: 'normal',
						formatter: this.formatters
					},{
						label: '资产类别',
						value: 'itemType',
						show: 'normal',
						formatter: this.formatterss
					}, {
						label: '行号',
						value: 'rowNum',
						show: 'normal'
					},{
						label: '排序',
						value: 'orederBy',
						show: 'normal'
					},],
				operation: {
					label: '操作',
					value: 'operation',
					width: 200,
					data: [
						{label:'修改',value:'editBtn',},
						{label:'删除',value:'delete',}
					]
				},
				data: [],
				center: {
					textAlign: 'center',
					padding: '6px 0'
				}
			}
		}
	},
	created(){
		this.init();
		this.getReportTemplate();
    this.handleGetAccountingList();
	},
	methods:{
		init(){

		},
    // 获取会计制度
    async handleGetAccountingList() {
      const { data } = await getAccountingList();
      console.log("handleGetAccountingList",data);
	  if(data.code == 1){
	  this.options.prosetes = data.data.filter(x=>{
		x.id = Number(x.id)
		return x
	  })
	  }
    },
		// 弹框显示
		showDialog(val) {
			this.isShowReport = val;
		},
		// 重载数据
		refresh(val) {
			val && this.reportFormTemplateList();
		},
		// 列表名称点击事件
		handlerClick(row) {
      let newProject = false;
      //当用户查询后 并且为  民间非盈利性组织 业务活动表 + 内容名称
      if(this.ifSearchs && this.form.type == '3' && this.form.prosetId == 70 && row.formulaType == 1){
        newProject = true;
      };
			this.reportDialogData = Object.assign({}, this.reportDialogData, {
				reportFormTemplateId: row.id,
				prosetId: this.form.prosetId,
        shows:newProject,
			});
			this.isShowReport = true;
		},
		// 格式化数据
		formatter (row, column) {
			switch(row.isFormula){
				case '0':
					return '非公式';
					break;
				case '1':
					return '普通公式';
					break;
				case '2':
					return '可选择输入值';
					break;
				default :
					return '未知';
					break;
			}
		},
		formatterss (row, column) {
			switch(row.itemType){
				case 1:
					return '资产';
					break;
				case 2:
					return '负债';
					break;
				default :
					return '未知';
					break;
			}
		},
		formatters (row, column) {
			switch(row.formulaType){
				case 1:
					return '内容名称';
					break;
				case 2:
					return '分类汇总';
					break;
				case 3:
					return '分类名称';
					break;
				case 4:
					return '汇总';
					break;
				default :
					return '未知';
					break;
			}
		},
    //判断用户是否进行了查询
    ifChanges(){
      this.ifSearchs = false;
    },
		// 根据类型查找报表模板
		reportFormTemplateList() {
			try{
        this.ifSearchs = true;
				this.tableData.loading = true;
				this.$http.post('reportFormTemplate/reportFormTemplateList',this.form).then(res=>{
					this.tableData.loading = false;
					if(res.data.code=='1') {
						this.tableData.data = res.data.data;
					}
				});
			}catch(e){
				this.tableData.loading = false;
			}
		},
		// 获取报表模板类型
		getReportTemplate() {
			this.$http.post('sys/dict/list',{type: 'reportform_type'}).then(res=>{
				if(res.data.code=='1') {
					this.options.reportFormType = res.data.data;
					this.form.type = res.data.data[0].value;
					this.$nextTick(()=>{
						this.reportFormTemplateList();
					});
				}
			});
		},
		// 添加报表模板
		addReportMethod(){
			const _=this;
			_.$http.post('reportFormTemplate/saveReportFormTemplate',this.form).then(res=>{
				if(res.data.code==1) {
					this.dialog.modal = false;
					this.$message({
						type:'success',
						message: res.data.msg,
						showClose: true
					})
					this.reportFormTemplateList();
				}
			})
		},//表格操作按钮
		handleOperation({methods,row}){
			switch (methods) {
				case 'editBtn':
					this.editorMethods(row);
					break;
				case 'delete':
					this.deleteMethods(row);
					break;
			}
		},
		// 点击添加按钮
		dialogShow() {
			this.form = Object.assign(this.form , {
				isFormula: '',
				isFormula: '',
				rowNum: 1,
				orederBy: 1,
				itemType: '',
				formulaType: '',
				name: '',
				id: ''
			})
			console.log(this.form)
			this.dialog.modal = true;
		},
		//修改列表数据方法
		editorMethods(row){
			this.form = Object.assign(this.form , {
				type: row.type,
				prosetId: row.prosetId,
				isFormula:row.isFormula,
				rowNum: row.rowNum,
				orederBy: row.orederBy,
				formulaType: row.formulaType,
				name: row.name,
				itemType: row.itemType,
				id: row.id
			})
			this.dialog.modal = true;
		},
		//删除列表数据方法
		deleteMethods(row){
			 this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		        	this.$http.post('reportFormTemplate/delReportFormTemplateById',{reportFormTemplateId: row.id}).then(res=>{
			        	if(res.data.code==1) {

							this.$message({
								type:'success',
								message: res.data.msg,
								showClose: true
							})
							this.reportFormTemplateList();
						}
		        	})
			        this.$message({
			            type: 'success',
			            showClose: true,
			            message: '删除成功!'
			        });
		        }).catch(() => {
		          this.$message({
		            type: 'info',
		             showClose: true,
		            message: '已取消删除'
		          });
	        });
		},

	},
	mounted() {

	},
}
</script>

<style lang="less" scoped>
	#reportFormTemplate{

	}
</style>



// WEBPACK FOOTER //
// src/pages/setting/reportFormTemplate.vue